import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import Worksheets from './components/Worksheets'
import {VideoModalProvider} from './components/VideoModalContext'
import {AlphabetProvider} from './components/AlphabetContext';
import {SearchProvider} from './components/SearchContext';

const root = createRoot(document.getElementById('token-worksheets'))
root.render(
  <StrictMode>
    <VideoModalProvider>
      <SearchProvider>
        <AlphabetProvider>
          <Worksheets />
        </AlphabetProvider>
      </SearchProvider>
    </VideoModalProvider>
  </StrictMode>
)
